"use client"

import { memo } from "react";
import { ResultView as BaseResultView } from "./ResultView";

export const ResultViewMemo = memo(BaseResultView, (prev, next) => {
  return (
    prev.keyName === next.keyName &&
    prev.paperName === next.paperName &&
    prev.taskId === next.taskId &&
    prev.result === next.result &&
    prev.status === next.status &&
    prev.extractStatus === next.extractStatus &&
    prev.isPolling === next.isPolling &&
    prev.className === next.className &&
    // images/tables 可能是大对象，尽量依赖稳定引用
    prev.images === next.images &&
    prev.tables === next.tables &&
    prev.onRetry === next.onRetry &&
    prev.onRefresh === next.onRefresh &&
    prev.attachmentId === next.attachmentId
  );
});


